/*
 *
 * GoldRedirect constants
 *
 */
/* eslint-disable max-len */
export const CHANGE_INPUT_VALUE = 'app/GoldRedirect/CHANGE_INPUT_VALUE';

export const GOLD_MIGRATION_LOGIN_REQUEST = 'app/GoldRedirect/GOLD_MIGRATION_LOGIN_REQUEST';
export const GOLD_MIGRATION_LOGIN_REQUEST_FAILURE = 'app/GoldRedirect/GOLD_MIGRATION_LOGIN_REQUEST_FAILURE';
export const GOLD_MIGRATION_LOGIN_REQUEST_SUCCESS = 'app/GoldRedirect/GOLD_MIGRATION_LOGIN_REQUEST_SUCCESS';

export const REDIRECT_TO_PAYMENTS_PAGE = 'app/GoldRedirect/REDIRECT_TO_PAYMENTS_PAGE';

export const RESET_FORM_ERRORS = 'app/Main/RESET_FORM_ERRORS';

export const SET_GOLD_MIGRATION_COOKIES = 'app/GoldRedirect/SET_GOLD_MIGRATION_COOKIES';

export const UPDATE_GOLD_MIGRATION_SESSION = 'app/GoldRedirect/UPDATE_GOLD_MIGRATION_SESSION';

export const UPDATE_IS_USERNAME_REQUIRED = 'app/GoldRedirect/UPDATE_IS_USERNAME_REQUIRED';

export const UPDATE_PROFILE_TRANSFER_STEP = 'app/GoldRedirect/UPDATE_PROFILE_TRANSFER_STEP';

export const API_REASON_CODE_DICTIONARY = {
  3006.2006: { key: 'username', message: 'Username is required' },
  3006.2007: { key: 'password', message: 'Password is required' },
  3006.2015: { key: 'password', message: 'Password must be at least 10 characters long and must contain at least 1 lower case, 1 upper case and 1 number' },
  3006.2018: { key: 'username', message: 'Username is already in use' },
  3006.2027: { key: 'username', message: 'Username can contain only letters and Numbers and must be at least 5 characters long' },
};

export const PROFILE_TRANSFER_ERROR_PAGE_COPY = {
  desktopPath: '/register',
  header: 'Sorry, something unexpected happened',
  linkLabel: 'Register Loan ',
  mobilePath: 'Register',
  text: 'An error occurred while migrating to the new site. Please login once more to initiate the process again. If the problem persists, you can click on the link below to manually register your loan on the new site.',
};

export const MOBILE_REDIRECT_LINK_DICT = {
  Prelogin: '/prelogin',
  Preregistration: '/preregistration',
};

export const PROFILE_TRANSFER_CONFIRMATION_PROPS = {
  getHeader: (isUsernameRequired) => isUsernameRequired
    ? 'Success! Your username and password\nhave been updated'
    : 'Success!\nYour password has been updated',
  linkLabel: 'Continue to New Site',
  text: 'You will be redirected to the new site in 5 seconds. Or continue by clicking on the link below.',
};

export const PROFILE_TRANSFER_FORM_CONTENT_DICTIONARY = {
  accountTransferredLinkLabel: 'Continue to New Site',
  noRequiredField: {
    header: 'Our new mortgage website is here',
    text: 'We have transitioned our customers to an new online mortgage platform. You will now be able to access two or more of your loans using your existing login credentials.',
  },
  onlyPasswordRequired: {
    header: 'It’s time to move to the new website',
    text: 'Please update your password to gain access to the new online mortgage platform. Going forward, you can continue using your current username in combination with the new password.',
  },
  passwordAndUsernameRequired: {
    header: 'It’s time to move to the new website',
    text: 'Please create a new username and password to gain access to the updated online mortgage platform. Going forward, you will use your new credentials to login.',
  },
  submitButtonLabel: 'Submit',
};

export const REDIRECT_CARD_PROPS_DICT = {
  '/prelogin': {
    desktopPath: '/login',
    header: "You've already transferred your account to the new online mortgage platform",
    label: 'Login Now',
    mobilePath: 'Login',
    text: 'Please go to the new website to continue.',
  },
  '/preregistration': {
    desktopPath: '/register',
    header: 'Register on our new website',
    label: 'Register Account',
    mobilePath: 'Register',
    text: "We've moved all of our customers to a new online mortgage platform with a fresh look. Please register your account there.",
  },
};
